<template>

	<div class="onboarding">
		<div class="onboarding-top">
			<h2>Reading Stories</h2>
			<p>You can use these gestures to start <br> reading “INSERT TITLE”</p>
		</div>

		<div class="onboarding-wrap d-flex" @click="onNext()">
			<div class="onboarding-single"  :class="{ 'hide' : num!=0, 'show':num==2 }">
				<img class="lg-img" src="../../assets/icon/Go-Back.svg" alt="Go-Back">
				<img class="sm-img" src="../../assets/icon/go-back-sm.svg" alt="Go-Back">
				<h4>Go Back</h4>
				<p>Click on the left <br>Or use the left arrow</p>
			</div>
			<div class="onboarding-single" :class="{ 'hide' : num!=0, 'show':num==3 }">
				<img class="lg-img" src="../../assets/icon/autoplay.svg" alt="Go-Back">
				<img class="sm-img" src="../../assets/icon/autoplay-sm.svg" alt="Go-Back">
				<h4>Autoplay</h4>
				<p>Click and hold <br>Or hit the spacebar</p>
			</div>
			<div class="onboarding-single" :class="{ 'hide' : num!=0, 'show':num==1 }">
				<img class="lg-img" src="../../assets/icon/Go-Forward.svg" alt="Go-Back">
				<img class="sm-img" src="../../assets/icon/Go-Forward-sm.svg" alt="Go-Back">
				<h4>Go Forward</h4>
				<p>Click on the right <br>or use the right arrow</p>
			</div>
		</div>

		<div class="onboarding-arrow" :class="{ 'hide' : num!=0}">
			<img class="lg-img" 
				 src="../../assets/icon/onboarding-shape-lg.svg" 
				 alt="onboarding-shape-lg" />
			<img class="sm-img"  
			     src="../../assets/icon/onboarding-shape-sm.svg" 
			     alt="onboarding-shape-sm" />
		</div>
	</div>

</template>


<script>
	import { EventBus } from '../../main';
    export default {
     	name: "onboarding",

        data(){
		    return{
		    	num:0,
		    }
		},

		mounted(){

		},

		methods: {
			onNext() {
				this.num++;
				if(this.num==4) {
					EventBus.$emit('onboarding',true);
					localStorage.setItem('onboarding', true);
				}
			}
		}

    }

</script>

<style type="text/css">
	.onboarding {
	    position: absolute;
	    top: 0;
	    left: 0;
	    background: rgba(40, 81, 125, 0.65);
	    width: 100%;
	    height: 100%;
	    line-height: initial;
	    display: -webkit-box;
	    display: -ms-flexbox;
	    display: flex;
	    -webkit-box-pack: center;
	        -ms-flex-pack: center;
	            justify-content: center;
	    -webkit-box-align: center;
	        -ms-flex-align: center;
	            align-items: center;
    	-webkit-box-orient: vertical;
    	-webkit-box-direction: normal;
    	    -ms-flex-direction: column;
    	        flex-direction: column;
    	z-index: 999;
    	cursor: pointer;
	}

	.onboarding-wrap {
	    width: 100%;
	    -ms-flex-pack: distribute;
	        justify-content: space-around;
	}	

	.onboarding-top {
	    text-align: center;
	    margin-bottom: 40px;
	}

	.onboarding-top h2 {
	    color: #ffffff;
	    letter-spacing: 0.1714285px;
	}


	.onboarding-top p {
	    color: #ffffff;
	    font-size: 18px;
	    line-height: 30px;
	    letter-spacing: 0.1285714px;
	}

	.onboarding-single {
	    text-align: center;
	}

	.onboarding-single img {
	    width: 90px;
	    margin-bottom: 5px;
	}

	.onboarding-single h4 {
	    color: #ffffff;
	    font-size: 20px;
	    letter-spacing: 0.1428571px;
	}

	.onboarding-wrap div:nth-child(2) h4 {
	    margin-top: 5px;
	}

	.onboarding-single p {
	    color: #ffffff;
	    letter-spacing: 0.1142857px;
	}

	.onboarding-arrow{
		-webkit-transform: scale(1);
		    -ms-transform: scale(1);
		        transform: scale(1);
	    margin-top: -15px;
	    margin-left: 8em;
	}

	.hide{
		visibility: hidden;
	}

	.show{
		visibility: visible;
	}

	.sm-img{
		display: none;
	}

	@media only screen and (max-width: 767px) {

		.lg-img{
			display: none;
		}
		.sm-img {
		    display: inline-block;
		    margin: auto;
		    width: 50px;
		    margin-bottom: 10px;
		}
		.onboarding-arrow {
		    -webkit-transform: scale(4);
		    -ms-transform: scale(4);
		        transform: scale(4);
			margin-top: 35px;
		    margin-left: 5em;
		}

		.onboarding-single p {
		    margin-top: 5px;
		}

		.onboarding-single img {
		    width: 50px;
		    margin-bottom: 10px;
		}
	}


	@media only screen and (max-width: 480px) {

	    .onboarding-top h2 {
	        font-size: 18px;
	    }
	    .onboarding-top p {
	        margin-top: 5px;
	        margin-bottom: 10px;
	        font-size: 14px;
	        line-height: 22px;
	    }

	    .onboarding-single img {
	        width: 35px;
	    }

	    .onboarding-single h4 {
	        font-size: 16px;
	    }

	    .onboarding-single p {
	        margin-top: 5px;
	        font-size: 12px;
	        line-height: 20px;
	    }

	    .onboarding-arrow {
	        -webkit-transform: scale(3);
	        -ms-transform: scale(3);
	            transform: scale(3);
	        margin-top: 20px;
	        margin-left: 5em;
	    }

	}
	@media only screen and (max-width: 380px) {

	    .onboarding-top h2 {
	        font-size: 16px;
	    }
	    .onboarding-top p {
	        margin-top: 5px;
	        margin-bottom: 10px;
	        font-size: 12px;
	        line-height: 22px;
	    }

	    .onboarding-single img {
	        width: 25px;
	    }

		.onboarding-single h4 {
		    font-size: 13px;
		}

		.onboarding-single p {
		    margin-top: 5px;
		    font-size: 12px;
		    line-height: 16px;
		}
	    
	}
</style>